import React from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import MainLayout from '../Layout/MainLayout';
import AccountMainLayout from '../Layout/AccountMainLayout';
import ContactForm from '../components/ContactForm';

const ContactUs = () => {
  const isLoggedIn = !!Cookies.get('userToken');
  const Layout = isLoggedIn ? AccountMainLayout : MainLayout;
  const { personalDetail } = useSelector((state) => state.signup);

  const prefillName = isLoggedIn
    ? personalDetail?.fullName || personalDetail?.name || ''
    : '';
  const prefillEmail = isLoggedIn ? personalDetail?.email || '' : '';
  const prefillPhone = isLoggedIn
    ? personalDetail?.phoneNumber || personalDetail?.telephone || ''
    : '';

  return (
    <Layout>
      <div className="shopify-section-template">
        <div className="container">
          <div className="row">
            <div className="template">
              <div className="shopify mb-4">
                <h3 className="section-heading">CONTACT US</h3>
                <p className="email-text">
                  Need help with your membership or account? Send us a message
                  and our team will get back to you.
                </p>
                <p className="email-text">
                  You can also email us at{' '}
                  <a href="mailto:info@mycalibercard.com">
                    info@mycalibercard.com
                  </a>
                </p>
              </div>
              <ContactForm
                prefillName={prefillName}
                prefillEmail={prefillEmail}
                prefillPhone={prefillPhone}
              />
              <p className="form-text-last mt-3 mb-0">
                By completing this form, you agree that Caliber Card may contact
                you at the email address or phone number above.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;
